import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { deleteData } from 'src/app/page/masterdata/dummy-routes/dummy-routes.component';

@Component({
    selector: 'app-delete-dummy-route',
    templateUrl: './delete-dummy-route.component.html',
    styleUrls: ['./delete-dummy-route.component.scss'],
    standalone: false // NOSONAR
})
export class DeleteDummyRouteComponent implements OnInit {
  content;
  id;
  pageName;

  constructor(public dialogRef: MatDialogRef<DeleteDummyRouteComponent>, 
    @Inject(MAT_DIALOG_DATA) public dataStore: deleteData) { 
      
      if(this.dataStore.page == 'dummy route'){ // NOSONAR
        this.pageName = "Dummy Route";
        this.content = this.dataStore.route_name;
        this.id = this.dataStore.id;
      }
    }

  ngOnInit(): void { // NOSONAR 

  }

  close(): void {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  public saveClick() {    
    this.dialogRef.close({data:this.id});

  }
}
